// extracted by mini-css-extract-plugin
export default {"text":"xE0xscH8wG"};